var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"-z-10 relative flex flex-grow items-center justify-center w-full",class:{
    'flex w-full justify-center items-center': !_vm.isMobile,
    'max-h-96 min-h-20': _vm.isMobile,
  },attrs:{"id":"logoWrapper"}},[_c('img',{staticClass:"logo w-full object-contain",class:{ 'max-h-36': _vm.isMobile, 'max-h-48': !_vm.isMobile },attrs:{"src":_vm.src,"alt":"logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }